import React from 'react';

const Montenegro = (props) => (
<img src="https://flagsapi.com/ME/flat/64.png" width={40} height={'auto'} />
);

export default Montenegro;



